export const validateInput = (curr: any, t: any) => {
  //Note validate and display error is 2 separate functions b/c w/ button disabled only want to check, not show error
  let returnVal: any = false;
  let msg: string = '';

  if (Array.isArray(curr['content'])) {
    if (curr['content'].length === 0) {
      return {
        error: true,
        msg: t('sellerProfile.dashboard.validation.required')
      };
    } else {
      return { error: false, msg: '' };
    }
  }
  let content = curr['content']?.trim();
  if (curr['validate'] === 'text') {
    if (curr['content'].length === 0) {
      return {
        error: true,
        msg: t('sellerProfile.dashboard.validation.required')
      };
    }
  } else if (curr['validate'] === 'iata') {
    if (!/^[0-9]{8}$/.test(curr['content'])) {
      return { error: true, msg: t('sellerProfile.dashboard.validation.iata') };
    }
  }

  if (curr['content'] && curr['content'].length === 0) {
    return { error: false };
  } else if (curr['validate'] === 'iataNumber') {
    if (!/^[0-9]{8}$/.test(curr['content'])) {
      return { error: true, msg: t('sellerProfile.dashboard.validation.iata') };
    }
  }
  //Un utilisateur est déjà associé à cette adresse électronique.
  //Veuillez entrer une adresse électronique valide (les adresses personnelles ne sont pas autorisées).
  //Veuillez saisir un numéro de téléphone valide.
  if (curr['content']?.length && curr['validate']) {
    if (curr['validate'] === 'email') {
      let re = /\S+@\S+\.\S+/;
      returnVal = !re.test(content);

      const blacklist = [
        '@gmail.',
        '@yahoo.',
        '@hotmail.',
        '@aol.',
        '@msn.',
        '@outlook.',
        '@mail.',
        '@protonmail.',
        '@zoho.',
        '@icloud.',
        '@gmx.',
        '@yandex.',
        '@fastmail.',
        '@tutanota.',
        '@hushmail.',
        '@runbox.',
        '@inbox.',
        '@zimbra.',
        '@sapo.pt',
        '@walla.'
      ];

      blacklist.forEach((b) => {
        if (content.includes(b)) {
          returnVal = true;
        }
      });
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.email');
      }
    } else if (curr['validate'] === 'phone') {
      let re = /^[0-9+(][0-9 \-().]{7,14}$/;
      //Allows 7 - 32 numbers and + . () - and spaces only
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.phone');
      }
    } else if (curr['validate'] === 'url') {
      let re =
        /^[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.url');
      }
    } else if (curr['validate'] === 'alpha') {
      let re = /^[a-zA-Z.,\- ]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.alpha');
      }
    } else if (curr['validate'] === 'alphanumeric') {
      let re = /^[a-zA-Z0-9,. ]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.alphanumeric');
      }
    } else if (curr['validate'] === 'numeric') {
      let re = /^[0-9., ]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.numeric');
      }
    } else if (curr['validate'] === 'numericpercent') {
      let re = /^[0-9%:,.]*$/;
      returnVal = !re.test(content);
      if (returnVal) {
        msg = t('sellerProfile.dashboard.validation.numericpercent');
      }
    }
  }
  return { error: returnVal, msg: msg };
};
